/** PURE_IMPORTS_START .._operators_zip PURE_IMPORTS_END */
import { zipStatic } from '../operators/zip';
export var zip = zipStatic;
//# sourceMappingURL=zip.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/zip.js
// module id = ./node_modules/rxjs/_esm5/observable/zip.js
// module chunks = vendor